import { connect } from "react-redux";
import { get } from "lodash";
import { PosDetailsComponent } from "./PosDetails";
import { updateProspect } from "../../../../../../store/actions/appConfig";
import { getOrganizationInfoRO } from "../../../../../../store/selectors/appConfig";

const mapStateToProps = state => ({
  machineProvider: get(getOrganizationInfoRO(state), "posDetails.machineProvider", [""])
});

const mapDispatchToProps = {
  updateProspect
};
export const PosDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(PosDetailsComponent);
